// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

/* Shortcut Input Style */

.jp-Shortcuts-InputBox {
  display: inline-flex;
  padding-top: 2px;
}

.jp-Shortcuts-InputBoxNew {
  margin-left: 10px;
}

.jp-mod-hidden {
  display: none;
}

@keyframes slide-animation {
  from {
    width: 0;
    left: 0;
  }

  to {
    width: 120px;
    left: 0;
  }
}

.jp-Shortcuts-Input {
  animation-duration: 0.3s;
  animation-timing-function: ease-out;
  animation-name: slide-animation;
  border-width: var(--jp-border-width);
  border-color: var(--jp-border-color3);
  border-style: solid;
  background-color: var(--jp-layout-color0);
  margin-left: auto;
  padding-left: 10px;
  width: 120px;
  height: 25px;
  line-height: 25px;
  display: block;
}

.jp-Shortcuts-Input:focus {
  outline: none;
  color: var(--jp-content-font-color1);
  border-color: var(--jp-brand-color2);
}

.jp-mod-unavailable-Input:focus {
  border-color: var(--jp-error-color2);
}

.jp-Shortcuts-InputText {
  overflow-x: hidden;
  overflow-y: hidden;
  margin: 0;
  margin-top: 4px;
  padding: 0 5px;
  height: 17px;
  line-height: 17px;
  width: fit-content;
}

.jp-mod-selected-InputText {
  background-color: var(--jp-shortcuts-button-background);
  overflow: hidden;
}

.jp-mod-waiting-InputText {
  color: var(--jp-content-font-color3);
}

.jp-Shortcuts-Submit {
  background-color: var(--jp-brand-color2);
  border-radius: 0;
  border: none;
  color: var(--jp-layout-color0);
  font-family: var(--jp-ui-font-family);
  display: block;
  height: 27px;
  width: 26px;
  cursor: pointer;
}

.jp-Shortcuts-Submit:focus {
  outline: none;
}

.jp-Shortcuts-Submit .jp-icon3[fill] {
  fill: var(--jp-layout-color1);
}

.jp-Shortcuts-Submit.jp-mod-defunc-Submit {
  background-color: var(--jp-layout-color3);
}

.jp-Shortcuts-Submit.jp-mod-defunc-Submit .jp-icon3[fill] {
  fill: var(--jp-inverse-layout-color1);
}

.jp-Shortcuts-Submit.jp-mod-conflict-Submit {
  background-color: var(--jp-error-color1);
}

/* Shortcut Item Style */
.jp-Shortcuts-Cell {
  padding: 6px 12px;
  display: table-cell;
  width: 20%;
  vertical-align: middle;
}

.jp-Shortcuts-ShortcutCell {
  display: flex;
  min-width: max-content;
  flex-wrap: wrap;
}

.jp-Shortcuts-EmptyCell {
  height: 32px;
}

.jp-Shortcuts-Row {
  padding: 10px;
  width: 100%;
  display: table-row;
  border-bottom: var(--jp-border-width) solid var(--jp-border-color1);
  vertical-align: middle;
  background-color: var(--jp-layout-color0);
}

.jp-Shortcuts-Row:hover .jp-Shortcuts-ShortcutKeys {
  border-color: var(--jp-border-color1);
  background: var(--jp-layout-color2);
}

.jp-Shortcuts-Row:hover .jp-Shortcuts-Plus,
.jp-Shortcuts-Row:hover .jp-Shortcuts-Or {
  opacity: 1;
}

.jp-Shortcuts-ErrorMessage {
  color: var(--jp-error-color1);
  align-self: center;
}

.jp-Shortcuts-RowWithConflict {
  height: 45px;
  position: relative;
}

.jp-Shortcuts-ErrorButton {
  margin-left: 12px;
  white-space: nowrap;
}

.jp-Shortcuts-ErrorButton > button {
  margin-right: 12px;
}

.jp-Shortcuts-ShortcutContainer {
  display: flex;
  flex-wrap: wrap;
}

.jp-Shortcuts-ShortcutContainer:hover .jp-Shortcuts-ShortcutKeys {
  border-color: var(--jp-border-color3);
  background: var(--jp-layout-color3);
}

.jp-Shortcuts-ShortcutKeysContainer {
  font-size: var(--jp-code-font-size);
  font-family: var(--jp-ui-font-family);
  display: flex;
}

.jp-Shortcuts-ConflictContainer {
  display: block;
  padding: 6px 12px;
  position: absolute;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.jp-Shortcuts-Conflict {
  display: flex;
  flex-wrap: nowrap;
}

.jp-Shortcuts-ShortcutKeys {
  border-width: var(--jp-border-width);
  border-color: var(--jp-layout-color0);
  border-radius: var(--jp-border-radius);
  padding: 5px 6px;
  margin: 3px 0;
  cursor: pointer;
}

.jp-Shortcuts-Or {
  margin-right: 12px;
  margin-left: 12px;
  margin-top: 8px;
  color: var(--jp-content-font-color3);
  opacity: 0;
}

.jp-Shortcuts-Or:hover {
  opacity: 1;
}

.jp-Shortcuts-Or-Forced {
  opacity: 1;
}

.jp-Shortcuts-Comma {
  margin-top: 10px;
  margin-right: 2px;
  margin-left: 2px;
}

.jp-Shortcuts-Plus {
  opacity: 0;
  background: var(--jp-shortcuts-button-background);
  border-color: var(--jp-layout-color0);
  border-radius: var(--jp-border-radius);
  border-width: var(--jp-border-width);
  margin: 3px 0;
  padding: 5px 6px;
  color: var(--jp-ui-inverse-font-color1);
  cursor: pointer;
}

.jp-Shortcuts-Plus:hover {
  background: var(--jp-shortcuts-button-hover-background);
}

.jp-Shortcuts-Plus:active {
  background-color: var(--jp-brand-color2);
}

.jp-Shortcuts-Reset {
  color: var(--jp-brand-color2);
  padding-left: 10px;
  cursor: pointer;
}

.jp-Shortcuts-Reset:hover {
  color: var(--jp-brand-color1);
}

.jp-Shortcuts-SourceCell {
  display: inline-block;
}

/* Shortcut List Style */
.jp-Shortcuts-ShortcutList {
  width: 100%;
  display: table;
  border-collapse: collapse;
}

.jp-Shortcuts-ShortcutListContainer {
  overflow-y: scroll;
  border: var(--jp-border-width) solid var(--jp-border-color1);
}

/* Shortcut Title Item Style */
.jp-Shortcuts-Header {
  display: flex;
  cursor: pointer;
}

.jp-Shortcuts-Header:hover .jp-ShortcutTitleItem-sortButton .jp-icon3[fill],
.jp-Shortcuts-Header:focus .jp-ShortcutTitleItem-sortButton .jp-icon3[fill] {
  fill: var(--jp-ui-font-color0);
}

.jp-Shortcuts-Header:active .jp-ShortcutTitleItem-sortButton {
  outline: none;
}

.jp-Shortcuts-CurrentHeader .jp-icon3[fill] {
  fill: var(--jp-ui-font-color0);
}

/* Shortcut UI Style */

.jp-Shortcuts-ShortcutUI {
  display: flex;
  flex-direction: column;
  font-size: var(--jp-ui-font-size1);
  font-family: var(--jp-ui-font-family);
  color: var(--jp-content-font-color1);
  min-width: 450px;
  width: 100%;
}

/* TopNav Style */
.jp-Shortcuts-Top {
  display: block;
}

.jp-Shortcuts-TopNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: var(--jp-ui-font-size1);
  background-color: var(--jp-layout-color0);
}

.jp-Shortcuts-Symbols {
  padding: 0 12px;
}

.jp-Shortcuts-Symbols td:nth-child(2) {
  padding-right: 10px;
}

.jp-Shortcuts-AdvancedOptions {
  padding-left: 12px;
}

.jp-Shortcuts-AdvancedOptionsLink {
  color: var(--jp-content-link-color);
  margin-right: 15px;
  display: inline-block;
  cursor: pointer;
}

.jp-Shortcuts-AdvancedOptionsLink:hover {
  color: var(--jp-brand-color0);
  text-decoration: underline;
}

.jp-Shortcuts-AdvancedOptionsLink:active {
  color: var(--jp-brand-color0);
  text-decoration: underline;
}

.jp-Shortcuts-HeaderRowContainer {
  padding-right: 14px;
}

.jp-Shortcuts-HeaderRow {
  font-weight: bold;
  font-size: var(--jp-ui-font-size1);
  background-color: var(--jp-layout-color0);
  width: 100%;
  z-index: 1;
  display: table;
  padding: 10px 0;
}

.jp-Shortcuts-commandIcon {
  margin-right: 13px;
}

.jp-Shortcuts-altIcon {
  margin-right: 14px;
}

.jp-Shortcuts-controlIcon {
  margin-left: 8px;
  margin-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/shortcuts-extension/style/base.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E,yBAAyB;;AAEzB;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,QAAQ;IACR,OAAO;EACT;;EAEA;IACE,YAAY;IACZ,OAAO;EACT;AACF;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mEAAmE;EACnE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iDAAiD;EACjD,qCAAqC;EACrC,sCAAsC;EACtC,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,yCAAyC;EACzC,WAAW;EACX,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Distributed under the terms of the Modified BSD License.\n|----------------------------------------------------------------------------*/\n\n/* Shortcut Input Style */\n\n.jp-Shortcuts-InputBox {\n  display: inline-flex;\n  padding-top: 2px;\n}\n\n.jp-Shortcuts-InputBoxNew {\n  margin-left: 10px;\n}\n\n.jp-mod-hidden {\n  display: none;\n}\n\n@keyframes slide-animation {\n  from {\n    width: 0;\n    left: 0;\n  }\n\n  to {\n    width: 120px;\n    left: 0;\n  }\n}\n\n.jp-Shortcuts-Input {\n  animation-duration: 0.3s;\n  animation-timing-function: ease-out;\n  animation-name: slide-animation;\n  border-width: var(--jp-border-width);\n  border-color: var(--jp-border-color3);\n  border-style: solid;\n  background-color: var(--jp-layout-color0);\n  margin-left: auto;\n  padding-left: 10px;\n  width: 120px;\n  height: 25px;\n  line-height: 25px;\n  display: block;\n}\n\n.jp-Shortcuts-Input:focus {\n  outline: none;\n  color: var(--jp-content-font-color1);\n  border-color: var(--jp-brand-color2);\n}\n\n.jp-mod-unavailable-Input:focus {\n  border-color: var(--jp-error-color2);\n}\n\n.jp-Shortcuts-InputText {\n  overflow-x: hidden;\n  overflow-y: hidden;\n  margin: 0;\n  margin-top: 4px;\n  padding: 0 5px;\n  height: 17px;\n  line-height: 17px;\n  width: fit-content;\n}\n\n.jp-mod-selected-InputText {\n  background-color: var(--jp-shortcuts-button-background);\n  overflow: hidden;\n}\n\n.jp-mod-waiting-InputText {\n  color: var(--jp-content-font-color3);\n}\n\n.jp-Shortcuts-Submit {\n  background-color: var(--jp-brand-color2);\n  border-radius: 0;\n  border: none;\n  color: var(--jp-layout-color0);\n  font-family: var(--jp-ui-font-family);\n  display: block;\n  height: 27px;\n  width: 26px;\n  cursor: pointer;\n}\n\n.jp-Shortcuts-Submit:focus {\n  outline: none;\n}\n\n.jp-Shortcuts-Submit .jp-icon3[fill] {\n  fill: var(--jp-layout-color1);\n}\n\n.jp-Shortcuts-Submit.jp-mod-defunc-Submit {\n  background-color: var(--jp-layout-color3);\n}\n\n.jp-Shortcuts-Submit.jp-mod-defunc-Submit .jp-icon3[fill] {\n  fill: var(--jp-inverse-layout-color1);\n}\n\n.jp-Shortcuts-Submit.jp-mod-conflict-Submit {\n  background-color: var(--jp-error-color1);\n}\n\n/* Shortcut Item Style */\n.jp-Shortcuts-Cell {\n  padding: 6px 12px;\n  display: table-cell;\n  width: 20%;\n  vertical-align: middle;\n}\n\n.jp-Shortcuts-ShortcutCell {\n  display: flex;\n  min-width: max-content;\n  flex-wrap: wrap;\n}\n\n.jp-Shortcuts-EmptyCell {\n  height: 32px;\n}\n\n.jp-Shortcuts-Row {\n  padding: 10px;\n  width: 100%;\n  display: table-row;\n  border-bottom: var(--jp-border-width) solid var(--jp-border-color1);\n  vertical-align: middle;\n  background-color: var(--jp-layout-color0);\n}\n\n.jp-Shortcuts-Row:hover .jp-Shortcuts-ShortcutKeys {\n  border-color: var(--jp-border-color1);\n  background: var(--jp-layout-color2);\n}\n\n.jp-Shortcuts-Row:hover .jp-Shortcuts-Plus,\n.jp-Shortcuts-Row:hover .jp-Shortcuts-Or {\n  opacity: 1;\n}\n\n.jp-Shortcuts-ErrorMessage {\n  color: var(--jp-error-color1);\n  align-self: center;\n}\n\n.jp-Shortcuts-RowWithConflict {\n  height: 45px;\n  position: relative;\n}\n\n.jp-Shortcuts-ErrorButton {\n  margin-left: 12px;\n  white-space: nowrap;\n}\n\n.jp-Shortcuts-ErrorButton > button {\n  margin-right: 12px;\n}\n\n.jp-Shortcuts-ShortcutContainer {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.jp-Shortcuts-ShortcutContainer:hover .jp-Shortcuts-ShortcutKeys {\n  border-color: var(--jp-border-color3);\n  background: var(--jp-layout-color3);\n}\n\n.jp-Shortcuts-ShortcutKeysContainer {\n  font-size: var(--jp-code-font-size);\n  font-family: var(--jp-ui-font-family);\n  display: flex;\n}\n\n.jp-Shortcuts-ConflictContainer {\n  display: block;\n  padding: 6px 12px;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.jp-Shortcuts-Conflict {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.jp-Shortcuts-ShortcutKeys {\n  border-width: var(--jp-border-width);\n  border-color: var(--jp-layout-color0);\n  border-radius: var(--jp-border-radius);\n  padding: 5px 6px;\n  margin: 3px 0;\n  cursor: pointer;\n}\n\n.jp-Shortcuts-Or {\n  margin-right: 12px;\n  margin-left: 12px;\n  margin-top: 8px;\n  color: var(--jp-content-font-color3);\n  opacity: 0;\n}\n\n.jp-Shortcuts-Or:hover {\n  opacity: 1;\n}\n\n.jp-Shortcuts-Or-Forced {\n  opacity: 1;\n}\n\n.jp-Shortcuts-Comma {\n  margin-top: 10px;\n  margin-right: 2px;\n  margin-left: 2px;\n}\n\n.jp-Shortcuts-Plus {\n  opacity: 0;\n  background: var(--jp-shortcuts-button-background);\n  border-color: var(--jp-layout-color0);\n  border-radius: var(--jp-border-radius);\n  border-width: var(--jp-border-width);\n  margin: 3px 0;\n  padding: 5px 6px;\n  color: var(--jp-ui-inverse-font-color1);\n  cursor: pointer;\n}\n\n.jp-Shortcuts-Plus:hover {\n  background: var(--jp-shortcuts-button-hover-background);\n}\n\n.jp-Shortcuts-Plus:active {\n  background-color: var(--jp-brand-color2);\n}\n\n.jp-Shortcuts-Reset {\n  color: var(--jp-brand-color2);\n  padding-left: 10px;\n  cursor: pointer;\n}\n\n.jp-Shortcuts-Reset:hover {\n  color: var(--jp-brand-color1);\n}\n\n.jp-Shortcuts-SourceCell {\n  display: inline-block;\n}\n\n/* Shortcut List Style */\n.jp-Shortcuts-ShortcutList {\n  width: 100%;\n  display: table;\n  border-collapse: collapse;\n}\n\n.jp-Shortcuts-ShortcutListContainer {\n  overflow-y: scroll;\n  border: var(--jp-border-width) solid var(--jp-border-color1);\n}\n\n/* Shortcut Title Item Style */\n.jp-Shortcuts-Header {\n  display: flex;\n  cursor: pointer;\n}\n\n.jp-Shortcuts-Header:hover .jp-ShortcutTitleItem-sortButton .jp-icon3[fill],\n.jp-Shortcuts-Header:focus .jp-ShortcutTitleItem-sortButton .jp-icon3[fill] {\n  fill: var(--jp-ui-font-color0);\n}\n\n.jp-Shortcuts-Header:active .jp-ShortcutTitleItem-sortButton {\n  outline: none;\n}\n\n.jp-Shortcuts-CurrentHeader .jp-icon3[fill] {\n  fill: var(--jp-ui-font-color0);\n}\n\n/* Shortcut UI Style */\n\n.jp-Shortcuts-ShortcutUI {\n  display: flex;\n  flex-direction: column;\n  font-size: var(--jp-ui-font-size1);\n  font-family: var(--jp-ui-font-family);\n  color: var(--jp-content-font-color1);\n  min-width: 450px;\n  width: 100%;\n}\n\n/* TopNav Style */\n.jp-Shortcuts-Top {\n  display: block;\n}\n\n.jp-Shortcuts-TopNav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  font-size: var(--jp-ui-font-size1);\n  background-color: var(--jp-layout-color0);\n}\n\n.jp-Shortcuts-Symbols {\n  padding: 0 12px;\n}\n\n.jp-Shortcuts-Symbols td:nth-child(2) {\n  padding-right: 10px;\n}\n\n.jp-Shortcuts-AdvancedOptions {\n  padding-left: 12px;\n}\n\n.jp-Shortcuts-AdvancedOptionsLink {\n  color: var(--jp-content-link-color);\n  margin-right: 15px;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.jp-Shortcuts-AdvancedOptionsLink:hover {\n  color: var(--jp-brand-color0);\n  text-decoration: underline;\n}\n\n.jp-Shortcuts-AdvancedOptionsLink:active {\n  color: var(--jp-brand-color0);\n  text-decoration: underline;\n}\n\n.jp-Shortcuts-HeaderRowContainer {\n  padding-right: 14px;\n}\n\n.jp-Shortcuts-HeaderRow {\n  font-weight: bold;\n  font-size: var(--jp-ui-font-size1);\n  background-color: var(--jp-layout-color0);\n  width: 100%;\n  z-index: 1;\n  display: table;\n  padding: 10px 0;\n}\n\n.jp-Shortcuts-commandIcon {\n  margin-right: 13px;\n}\n\n.jp-Shortcuts-altIcon {\n  margin-right: 14px;\n}\n\n.jp-Shortcuts-controlIcon {\n  margin-left: 8px;\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
